import { useTranslation } from "react-i18next";

import { ActionKind } from "../../types/Action";
import { Button } from "../Button";
import { RootStateKind, useRootState } from "../state/StateProvider";

export const PaymentResponseSimulator = () => {
    const { t } = useTranslation();
    const {
        dispatch,
        state: { simulatePaymentResponse }
    } = useRootState(RootStateKind.Scan);

    return (
        <Button
            variant="secondary"
            className="z-10"
            onClick={() =>
                dispatch({ kind: ActionKind.TogglePaymentSimulator })
            }
        >
            {t("paymentSimulator")
                .concat(": ")
                .concat(t(simulatePaymentResponse ?? "success"))}
        </Button>
    );
};
